import React from 'react'
import styled from 'styled-components'
import {Alert, Button, Snackbar, TextField, Typography} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import {Loading, Page} from 'components/Page/index.js'
import OrganizationCard from 'components/Organizations/OrganizationCard.js'
import useMyOrganizations from 'logic/Organizations/useMyOrganizations.js'

const OrganizationsList = ({
    t,
    organizations,
    isLoading,
    showSaved,
    showError,
}) => {
    if (isLoading) {
        return <Loading loadingText={t('loading')} isLoading={isLoading} />
    }
    if (organizations.length === 0) {
        return <Typography color="text.secondary">{t('empty')}</Typography>
    }
    return organizations.map((organization) => (
        <OrganizationCard
            key={organization._id}
            organization={organization}
            t={t}
            showSaved={showSaved}
            showError={showError}
        />
    ))
}

const MyOrganizations = () => {
    const {
        t,
        organizations,
        isLoading,
        newName,
        isCreating,
        handleNewNameChange,
        handleCreate,
        snackbar,
        closeSnackbar,
        showSaved,
        showError,
    } = useMyOrganizations()

    return (
        <Page title={t('title')}>
            <Container>
                <CreateForm onSubmit={handleCreate}>
                    <TextField
                        size="small"
                        label={t('newName')}
                        value={newName}
                        onChange={handleNewNameChange}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        startIcon={<AddIcon />}
                        disabled={isCreating || !newName.trim()}>
                        {t('add')}
                    </Button>
                </CreateForm>

                <OrganizationsList
                    t={t}
                    organizations={organizations}
                    isLoading={isLoading}
                    showSaved={showSaved}
                    showError={showError}
                />
            </Container>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={closeSnackbar}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
                <Alert
                    variant="filled"
                    onClose={closeSnackbar}
                    severity={snackbar.severity || 'success'}
                    sx={{width: '350px'}}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Page>
    )
}

export default MyOrganizations

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 20px;
    padding: 20px;

    @media (max-width: 600px) {
        padding: 10px;
    }
`

const CreateForm = styled.form`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
`
